import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "StudySkip"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 6.74993H20.4C18.4029 3.70279 14.6434 2.32645 11.1509 3.36383C7.65841 4.4012 5.25989 7.60664 5.25 11.2499H3.75C3.75209 7.14307 6.32741 3.47784 10.1904 2.08379C14.0534 0.689744 18.3758 1.86581 21 5.02493V2.24993H22.5V8.24993H16.5V6.74993ZM12 7.49991C9.92893 7.49991 8.25 9.17884 8.25 11.2499C8.25 13.321 9.92893 14.9999 12 14.9999C14.0711 14.9999 15.75 13.321 15.75 11.2499C15.75 9.17884 14.0711 7.49991 12 7.49991ZM11.9999 8.99992C13.2425 8.99992 14.2499 10.0073 14.2499 11.2499C14.2499 12.4926 13.2425 13.4999 11.9999 13.4999C10.7573 13.4999 9.74989 12.4926 9.74989 11.2499C9.73964 10.6501 9.97339 10.0718 10.3976 9.64763C10.8218 9.22343 11.4001 8.98967 11.9999 8.99992ZM15.75 22.4999H17.25V20.2499C17.25 19.2553 16.8549 18.3015 16.1517 17.5983C15.4484 16.895 14.4946 16.4999 13.5 16.4999H10.5C8.42893 16.4999 6.75 18.1788 6.75 20.2499V22.4999H8.25V20.2499C8.25 19.0073 9.25736 17.9999 10.5 17.9999H13.5C14.7426 17.9999 15.75 19.0073 15.75 20.2499V22.4999Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/StudySkip.vue"]]);
